export default "__VITE_ASSET__DpD7pz0s__"